var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"fill-height"},[_c('Stepper',{attrs:{"fetchedContract":_vm.contract}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }